<template>
  <div class="app-list-container">
    <div class="app-list">
      <div class="new-entity-section">
        <AppButton @click="openCreate()" label="Novo Alerta de Uso" />
      </div>

      <table>
        <tr>
          <th style="width: 20px; max-width: 20px; min-width: 20px;">ID</th>
          <th>Produto</th>
          <th>Porcentagem de Uso</th>
          <th>Valor</th>
          <th>Projeto</th>
          <th>Ativo</th>
          <th style="width: 120px; max-width: 120px; min-width: 120px;"></th>
        </tr>
        <tr v-for="data of usageAlerts" class="table-hover-row">
          <td>{{data.id}}</td>
          <td>{{data.product?.name}}</td>
          <td>{{data.percentage_threshold ?? '--'}} %</td>
          <td>{{data.value_threshold}}</td>
          <td>{{data.project?.name}}</td>
          <td>{{data.is_active ? 'Sim' : 'Não'}}</td>
          <td style="text-align: right;">
            <a @click="openEdit(data)">Editar</a>
            <a @click="remove(data)" class="delete-action">Excluir</a>
          </td>
        </tr>
      </table>

    </div>
  </div>
</template>

<script>
import { AppButton } from "../../../components";
import {
  usageAlertServiceInstance as usageAlertService,
  alertServiceInstance as alertService
} from "../../../services";

export default {
  name: "ListUsageAlerts",
  components: {
    AppButton
  },
  methods: {
    openCreate() {
      this.$router.push('/usage-alerts/create');
    },
    openEdit({ id }) {
      this.$router.push(`/usage-alerts/create?id=${id}`);
    },
    async remove({ id }) {
      await usageAlertService.deleteById(id);
      alertService.success({ desc: 'Alerta de Uso excluído!' });
      await this.load();
    },
    async load() {
      const data =  (await usageAlertService.findAll()) ?? [];
      this.usageAlerts.splice(0, this.usageAlerts.length);
      this.usageAlerts.push(...data);
    }
  },
  data: () => ({
    usageAlerts: []
  }),
  async mounted() {
    await this.load();
  }
}
</script>

<style scoped lang="scss">

</style>